import { FormList, HeaderTitle, Operation, Thumbnails } from '@/components';
import { getCooperatorList, updateCooperator, deleteCooperator } from '@/api';
import { st_cooperate } from '@/utils/statetype';
import { toDateTime } from '@/utils/utils';
import { Button, message, Table, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTable } from '@/hooks';
import moment from 'moment';
import ItemEdit from './components/ItemEdit';

const { statusObj } = st_cooperate;
function ConfigBanner() {
  const [query, setQuery] = useState({});
  const [datas, setDatas] = useState({});
  const [visible, setVisible] = useState(false);
  // useEffect(() => {
  //   if (!visible) {
  //     console.log("编辑隐藏")
  //     setDatas({})
  //   }
  // }, [visible]);
  const columns = {
    id: '展示编号',
    name: '名称',
    image: {
      title: '展示图片',
      render: e => <Thumbnails images={[e]} center />,
    },
    NOINDEX_status: {
      title: '是否启用',
      render: (e) => (
        <Switch
          checked={e.status === 1}
          checkedChildren='启用'
          unCheckedChildren='隐藏'
          onChange={(check) => updateCooperatorOperate({ id: e.id, status: check ? 1 : 0 })}
        />
      ),
    },
    NOINDEX_operation: {
      title: '操作',
      fixed: 'right',
      render: e => (
        <Operation
          listData={{
            update: () => {
              const { ...prop } = e;
              setVisible(true);
              setDatas({
                ...prop,
              });

            },
            delete: () => {
              deleteCooperator({
                body: {
                  id: e.id,
                },
              }).then(() => {
                message.success('删除成功');
                flagFn(true);
              });
            },
          }}
        />
      ),
    },
  };

  const { tableProps, flagFn } = useTable({
    columns,
    API: getCooperatorList,
    isInit: false,
    params: {
      query,
    },
  });

  const updateCooperatorOperate = (body) => {
    updateCooperator({ body: body }).then(() => {
      message.success('操作成功');
      flagFn();
    })
    // flagFn(true);
  };


  const formData = [
    {
      id: 'status',
      label: '是否启用',
      type: 'select',
      selects: statusObj,
    },
  ];

  const changeQuery = (value = {}) => {
    setQuery(value);
    flagFn(true);
  };

  return (
    <>
      <HeaderTitle />
      <FormList
        formData={formData}
        changeQuery={changeQuery}
        extraRender={
          <Button type="primary" disabled={!global.isOperable} onClick={() => setVisible(true)}>
            添加
          </Button>
        }
      />
      <Table {...tableProps} />
      <ItemEdit
        data={datas}
        visible={visible}
        onChange={res => {
          if (res) flagFn();
          setVisible(false);
          setDatas({});
        }}
      />
    </>
  );
}

export default ConfigBanner;
